import React from 'react';
import PropTypes from 'prop-types';

const EsemenyItem = (props) => {
  return (
    <div className={"col-md-4"} id={props.id}>
      <div className={"card" + (props.active ? ' card-active' : '')} onClick={() => props.onClick(props.item)} style={{ paddingTop: 10, paddingBottom: 4, cursor: 'pointer', marginTop: 20, marginBottom: 0, boxShadow: 'none' }}>
        <div className="card-body">
          <strong>{props.title}</strong>
          <p style={{ marginBottom: 0 }}>{' ('}{props.start}{')'}</p>
          <p style={{ marginBottom: 0 }}>{props.room}</p>
          <p>{props.info}</p>
        </div>
      </div>
    </div>
  );
};

EsemenyItem.defaultProps = {
  active: false,
  title: '-',
  start: '-',
  info: '-',
  onClick: () => {}
};

EsemenyItem.propTypes = {
  id: PropTypes.number,
  active: PropTypes.bool,
  title: PropTypes.string,
  start: PropTypes.string,
  info: PropTypes.string,
  onClick: PropTypes.func,
  room: PropTypes.string,
};

export default EsemenyItem;
